import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { PaymentMethodDtoPayload } from '@/modules/employee/employee.types';
import { formatPaymentMethod } from '@/modules/ReimburseMe/queries/useAddPaymentMethod.query';

interface Params {
  employeeId: string;
}
export const QUERY_KEY = 'GET_PAYMENT_METHODS';
const useGetPaymentMethodsQuery = ({ employeeId }: Params) => {
  const { data, isSuccess, isLoading, refetch } = useQuery([QUERY_KEY, employeeId], () =>
    // TODO: types is broken
    api.get<PaymentMethodDtoPayload[]>(API_URL.PAYMENT_METHODS, {
      params: { employee_id: employeeId },
    })
  );

  const formattedData = useMemo(
    () => (data?.data || []).map((paymentMethod) => formatPaymentMethod(paymentMethod)),
    [data]
  );

  return {
    isLoading,
    isSuccess,
    formattedData,
    refetch,
  };
};

export default useGetPaymentMethodsQuery;
